/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { BuilderUserContext } from '../user';

@Directive({
  selector: '[ghAllowForSandbox]',
})
export class AllowForSandboxDirective {
  constructor(private viewContainerRef: ViewContainerRef,
              private templateRef: TemplateRef<Object>,
              private userContext: BuilderUserContext) {
  }

  @Input()
  set ghAllowForSandbox(isAllowed: boolean) {
    if (this.userContext.sandbox) {
      if (isAllowed) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainerRef.clear();
      }
    } else {
      if (isAllowed) {
        this.viewContainerRef.clear();
      } else {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    }
  }
}
